import { gql } from "@apollo/client";

export const goalFragment = gql`
  fragment GoalFields on Goal {
    id
    l1Target
    l2Target
    l3Target
    l1CurrencyReward
    l2CurrencyReward
    l3CurrencyReward
    targetLevel
    targetPlan
    completedXP
    active
    enabled
    name
    categoryId
  }
`;